import Swal from 'sweetalert2';

export const showError = (titleOrMessage, maybeText) => {
  let title = 'Error';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'error', title, text });
};

export const showSuccess = (message) => {
  Swal.fire({ icon: 'success', title: 'Éxito', text: message });
};
export const showWarning = (titleOrMessage, maybeText) => {
  let title = 'Advertencia';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'warning', title, text });
};
export function showLoading(title = 'Procesando...', text = 'Esto puede tardar unos segundos') {
  Swal.fire({
    title,
    text,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
}

export function closeLoading() {
  Swal.close();
}

// Confirmación antes de cerrar un mes: al cerrar se calcula la propuesta del F29 con lo cargado en
// ese momento, y lo que se cargue después no entra. Resuelve true si el usuario confirma.
export async function confirmarCierreMes(nombreMes, anio) {
  const r = await Swal.fire({
    title: `¿Cerrar ${nombreMes} ${anio}?`,
    html: `Al cerrar el mes se calcula la propuesta del F29 con lo que está cargado <b>ahora</b>.
      Lo que se cargue después no entra al F29 y, al subir el F29 pagado, no cuadrará.<br><br>
      Antes de cerrar, confirma que revisaste que estén completos:<br>
      <div style="text-align:left;display:inline-block;margin-top:8px">
        • Compras · Ventas · Boletas SII · Ventas POS<br>
        • Retención de honorarios<br>
        • Recursos humanos: liquidaciones de sueldo<br>
        • Arriendos · Patentes
      </div>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, cerrar el mes',
    cancelButtonText: 'Cancelar'
  });
  return r.isConfirmed;
}

// Confirmación antes de eliminar la carga de un período. Resuelve true si el usuario confirma.
export async function confirmarEliminacion(title, html) {
  const r = await Swal.fire({
    title,
    html,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33'
  });
  return r.isConfirmed;
}

